import React from 'react';
import MortgageCalculator from '../components/calculator/MortgageCalculator';
import LeadCaptureForm from '../components/forms/LeadCaptureForm';

const MortgageCalculatorPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-10">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Mortgage <span className="text-red-600">Calculator</span>
          </h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Calculate your monthly mortgage payments, including CMHC insurance and closing costs. 
            Get a clear picture of what you can afford.
          </p>
        </div>

        <MortgageCalculator />

        {/* Pre-Approval CTA */}
        <div className="mt-16 max-w-4xl mx-auto">
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-8 md:p-12">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
              <div className="text-white">
                <h2 className="text-3xl font-bold mb-4">Ready to Get Pre-Approved?</h2>
                <p className="text-gray-300 mb-6">
                  A mortgage pre-approval shows sellers you're serious and helps you understand your true buying power. Let me connect you with trusted lenders.
                </p>
                <ul className="space-y-2 text-gray-300">
                  <li className="flex items-center gap-2">
                    <span className="w-5 h-5 bg-red-600 rounded-full flex items-center justify-center text-white text-xs">✓</span>
                    Know your exact budget
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="w-5 h-5 bg-red-600 rounded-full flex items-center justify-center text-white text-xs">✓</span>
                    Lock in your interest rate
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="w-5 h-5 bg-red-600 rounded-full flex items-center justify-center text-white text-xs">✓</span>
                    Strengthen your offers
                  </li>
                </ul>
              </div>
              <div>
                <LeadCaptureForm 
                  variant="compact" 
                  title="Get Pre-Approved" 
                  subtitle="I'll connect you with top lenders"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MortgageCalculatorPage;
